import { ConditionId } from '@patient/ui/SoapEntryPage/components/Template/SystemBlock/DentalTreatment/constants';

export { DentalCondition as Condition } from 'chaika-enums';

export enum ToothNumber {
    Tooth14 = '14',
    Tooth15 = '15',
    Tooth16 = '16',
    Tooth17 = '17',
    Tooth18 = '18',
    Tooth24 = '24',
    Tooth25 = '25',
    Tooth26 = '26',
    Tooth27 = '27',
    Tooth28 = '28',
    Tooth34 = '34',
    Tooth35 = '35',
    Tooth36 = '36',
    Tooth37 = '37',
    Tooth38 = '38',
    Tooth44 = '44',
    Tooth45 = '45',
    Tooth46 = '46',
    Tooth47 = '47',
    Tooth48 = '48',
    Tooth54 = '54',
    Tooth55 = '55',
    Tooth64 = '64',
    Tooth65 = '65',
    Tooth74 = '74',
    Tooth75 = '75',
    Tooth84 = '84',
    Tooth85 = '85',
    Tooth11 = '11',
    Tooth12 = '12',
    Tooth13 = '13',
    Tooth21 = '21',
    Tooth22 = '22',
    Tooth23 = '23',
    Tooth31 = '31',
    Tooth32 = '32',
    Tooth33 = '33',
    Tooth41 = '41',
    Tooth42 = '42',
    Tooth43 = '43',
    Tooth51 = '51',
    Tooth52 = '52',
    Tooth53 = '53',
    Tooth61 = '61',
    Tooth62 = '62',
    Tooth63 = '63',
    Tooth71 = '71',
    Tooth72 = '72',
    Tooth73 = '73',
    Tooth81 = '81',
    Tooth82 = '82',
    Tooth83 = '83',
}

export type FiveZoneToothNumber =
    | ToothNumber.Tooth14
    | ToothNumber.Tooth15
    | ToothNumber.Tooth16
    | ToothNumber.Tooth17
    | ToothNumber.Tooth18
    | ToothNumber.Tooth24
    | ToothNumber.Tooth25
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28
    | ToothNumber.Tooth34
    | ToothNumber.Tooth35
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38
    | ToothNumber.Tooth44
    | ToothNumber.Tooth45
    | ToothNumber.Tooth46
    | ToothNumber.Tooth47
    | ToothNumber.Tooth48
    | ToothNumber.Tooth54
    | ToothNumber.Tooth55
    | ToothNumber.Tooth64
    | ToothNumber.Tooth65
    | ToothNumber.Tooth74
    | ToothNumber.Tooth75
    | ToothNumber.Tooth84
    | ToothNumber.Tooth85;

export type FourZoneToothNumber =
    | ToothNumber.Tooth11
    | ToothNumber.Tooth12
    | ToothNumber.Tooth13
    | ToothNumber.Tooth21
    | ToothNumber.Tooth22
    | ToothNumber.Tooth23
    | ToothNumber.Tooth31
    | ToothNumber.Tooth32
    | ToothNumber.Tooth33
    | ToothNumber.Tooth41
    | ToothNumber.Tooth42
    | ToothNumber.Tooth43
    | ToothNumber.Tooth51
    | ToothNumber.Tooth52
    | ToothNumber.Tooth53
    | ToothNumber.Tooth61
    | ToothNumber.Tooth62
    | ToothNumber.Tooth63
    | ToothNumber.Tooth71
    | ToothNumber.Tooth72
    | ToothNumber.Tooth73
    | ToothNumber.Tooth81
    | ToothNumber.Tooth82
    | ToothNumber.Tooth83;

export type BabyLowerJawToothNumber =
    | ToothNumber.Tooth85
    | ToothNumber.Tooth84
    | ToothNumber.Tooth83
    | ToothNumber.Tooth82
    | ToothNumber.Tooth81
    | ToothNumber.Tooth71
    | ToothNumber.Tooth72
    | ToothNumber.Tooth73
    | ToothNumber.Tooth74
    | ToothNumber.Tooth75;

export type BabyUpperJawToothNumber =
    | ToothNumber.Tooth55
    | ToothNumber.Tooth54
    | ToothNumber.Tooth53
    | ToothNumber.Tooth52
    | ToothNumber.Tooth51
    | ToothNumber.Tooth61
    | ToothNumber.Tooth62
    | ToothNumber.Tooth63
    | ToothNumber.Tooth64
    | ToothNumber.Tooth65;

export type PermanentLowerJawToothNumber =
    | ToothNumber.Tooth48
    | ToothNumber.Tooth47
    | ToothNumber.Tooth46
    | ToothNumber.Tooth45
    | ToothNumber.Tooth44
    | ToothNumber.Tooth43
    | ToothNumber.Tooth42
    | ToothNumber.Tooth41
    | ToothNumber.Tooth31
    | ToothNumber.Tooth32
    | ToothNumber.Tooth33
    | ToothNumber.Tooth34
    | ToothNumber.Tooth35
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38;

export type PermanentUpperJawToothNumber =
    | ToothNumber.Tooth18
    | ToothNumber.Tooth17
    | ToothNumber.Tooth16
    | ToothNumber.Tooth15
    | ToothNumber.Tooth14
    | ToothNumber.Tooth13
    | ToothNumber.Tooth12
    | ToothNumber.Tooth11
    | ToothNumber.Tooth21
    | ToothNumber.Tooth22
    | ToothNumber.Tooth23
    | ToothNumber.Tooth24
    | ToothNumber.Tooth25
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28;

export type MixedLowerJawToothNumber =
    | ToothNumber.Tooth48
    | ToothNumber.Tooth47
    | ToothNumber.Tooth46
    | ToothNumber.Tooth45
    | ToothNumber.Tooth85
    | ToothNumber.Tooth44
    | ToothNumber.Tooth84
    | ToothNumber.Tooth43
    | ToothNumber.Tooth83
    | ToothNumber.Tooth42
    | ToothNumber.Tooth82
    | ToothNumber.Tooth41
    | ToothNumber.Tooth81
    | ToothNumber.Tooth31
    | ToothNumber.Tooth71
    | ToothNumber.Tooth32
    | ToothNumber.Tooth72
    | ToothNumber.Tooth33
    | ToothNumber.Tooth73
    | ToothNumber.Tooth34
    | ToothNumber.Tooth74
    | ToothNumber.Tooth35
    | ToothNumber.Tooth75
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38;

export type MixedUpperJawToothNumber =
    | ToothNumber.Tooth18
    | ToothNumber.Tooth17
    | ToothNumber.Tooth16
    | ToothNumber.Tooth15
    | ToothNumber.Tooth55
    | ToothNumber.Tooth14
    | ToothNumber.Tooth54
    | ToothNumber.Tooth13
    | ToothNumber.Tooth53
    | ToothNumber.Tooth12
    | ToothNumber.Tooth52
    | ToothNumber.Tooth11
    | ToothNumber.Tooth51
    | ToothNumber.Tooth21
    | ToothNumber.Tooth61
    | ToothNumber.Tooth22
    | ToothNumber.Tooth62
    | ToothNumber.Tooth23
    | ToothNumber.Tooth63
    | ToothNumber.Tooth24
    | ToothNumber.Tooth64
    | ToothNumber.Tooth25
    | ToothNumber.Tooth65
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28;

export type HiddenMixedBabyToothNumber =
    | ToothNumber.Tooth18
    | ToothNumber.Tooth17
    | ToothNumber.Tooth16
    | ToothNumber.Tooth48
    | ToothNumber.Tooth47
    | ToothNumber.Tooth46
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38;

export type LowerToothNumber =
    | ToothNumber.Tooth48
    | ToothNumber.Tooth47
    | ToothNumber.Tooth46
    | ToothNumber.Tooth45
    | ToothNumber.Tooth44
    | ToothNumber.Tooth43
    | ToothNumber.Tooth42
    | ToothNumber.Tooth41
    | ToothNumber.Tooth31
    | ToothNumber.Tooth32
    | ToothNumber.Tooth33
    | ToothNumber.Tooth34
    | ToothNumber.Tooth35
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38
    | ToothNumber.Tooth85
    | ToothNumber.Tooth84
    | ToothNumber.Tooth83
    | ToothNumber.Tooth82
    | ToothNumber.Tooth81
    | ToothNumber.Tooth71
    | ToothNumber.Tooth72
    | ToothNumber.Tooth73
    | ToothNumber.Tooth74
    | ToothNumber.Tooth75;

export type UpperToothNumber =
    | ToothNumber.Tooth55
    | ToothNumber.Tooth54
    | ToothNumber.Tooth53
    | ToothNumber.Tooth52
    | ToothNumber.Tooth51
    | ToothNumber.Tooth61
    | ToothNumber.Tooth62
    | ToothNumber.Tooth63
    | ToothNumber.Tooth64
    | ToothNumber.Tooth65
    | ToothNumber.Tooth18
    | ToothNumber.Tooth17
    | ToothNumber.Tooth16
    | ToothNumber.Tooth15
    | ToothNumber.Tooth14
    | ToothNumber.Tooth13
    | ToothNumber.Tooth12
    | ToothNumber.Tooth11
    | ToothNumber.Tooth21
    | ToothNumber.Tooth22
    | ToothNumber.Tooth23
    | ToothNumber.Tooth24
    | ToothNumber.Tooth25
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28;

export type RightToothNumber =
    | ToothNumber.Tooth21
    | ToothNumber.Tooth22
    | ToothNumber.Tooth23
    | ToothNumber.Tooth24
    | ToothNumber.Tooth25
    | ToothNumber.Tooth26
    | ToothNumber.Tooth27
    | ToothNumber.Tooth28
    | ToothNumber.Tooth31
    | ToothNumber.Tooth32
    | ToothNumber.Tooth33
    | ToothNumber.Tooth34
    | ToothNumber.Tooth35
    | ToothNumber.Tooth36
    | ToothNumber.Tooth37
    | ToothNumber.Tooth38
    | ToothNumber.Tooth61
    | ToothNumber.Tooth62
    | ToothNumber.Tooth63
    | ToothNumber.Tooth64
    | ToothNumber.Tooth65
    | ToothNumber.Tooth71
    | ToothNumber.Tooth72
    | ToothNumber.Tooth73
    | ToothNumber.Tooth74
    | ToothNumber.Tooth75;

export type LeftToothNumber =
    | ToothNumber.Tooth11
    | ToothNumber.Tooth12
    | ToothNumber.Tooth13
    | ToothNumber.Tooth14
    | ToothNumber.Tooth15
    | ToothNumber.Tooth16
    | ToothNumber.Tooth17
    | ToothNumber.Tooth18
    | ToothNumber.Tooth41
    | ToothNumber.Tooth42
    | ToothNumber.Tooth43
    | ToothNumber.Tooth44
    | ToothNumber.Tooth45
    | ToothNumber.Tooth46
    | ToothNumber.Tooth47
    | ToothNumber.Tooth48
    | ToothNumber.Tooth51
    | ToothNumber.Tooth52
    | ToothNumber.Tooth53
    | ToothNumber.Tooth54
    | ToothNumber.Tooth55
    | ToothNumber.Tooth81
    | ToothNumber.Tooth82
    | ToothNumber.Tooth83
    | ToothNumber.Tooth84
    | ToothNumber.Tooth85;

export enum ToothZone {
    WholeTooth = 'wholeTooth',
    Root = 'root',
    Crown = 'crown',
    One = '1',
    Two = '2',
    Three = '3',
    Four = '4',
    Five = '5',
}

export const jaw = 'jaw';

export type FourZoneSurfaceNumber = ToothZone.One | ToothZone.Two | ToothZone.Three | ToothZone.Four;
export type FiveZoneSurfaceNumber = ToothZone.One | ToothZone.Two | ToothZone.Three | ToothZone.Four | ToothZone.Five;

export type ZoneAmount = 4 | 5;

export type FourZoneSurfaceCondition = Record<FourZoneSurfaceNumber, ConditionId>;
export type FiveZoneSurfaceCondition = Record<FiveZoneSurfaceNumber, ConditionId>;

export type FourZoneSurfaceColors = Record<FourZoneSurfaceNumber, { fill: string; stroke: string }>;
export type FiveZoneSurfaceColors = Record<FiveZoneSurfaceNumber, { fill: string; stroke: string }>;

export enum ChangeTeethAction {
    Remove = 'remove',
}

export type FiveZoneToothState = {
    [key in
        | ToothZone.WholeTooth
        | ToothZone.Root
        | ToothZone.Crown
        | ToothZone.One
        | ToothZone.Two
        | ToothZone.Three
        | ToothZone.Four
        | ToothZone.Five]?: ConditionId | '';
};

export type FourZoneToothState = {
    [key in
        | ToothZone.WholeTooth
        | ToothZone.Root
        | ToothZone.Crown
        | ToothZone.One
        | ToothZone.Two
        | ToothZone.Three
        | ToothZone.Four]?: ConditionId | '';
};

export type DentalFormulaStateItem = FourZoneToothState | FiveZoneToothState;

// Selection

type FourZoneToothSelectionBase = {
    [key in
        | ToothZone.Root
        | ToothZone.Crown
        | ToothZone.One
        | ToothZone.Two
        | ToothZone.Three
        | ToothZone.Four]?: boolean;
};

export type FiveZoneToothSelectionBase = {
    [key in
        | ToothZone.Root
        | ToothZone.Crown
        | ToothZone.One
        | ToothZone.Two
        | ToothZone.Three
        | ToothZone.Four
        | ToothZone.Five]?: boolean;
};

export type DentalFormulaSelectionItem = FourZoneToothSelectionBase | FiveZoneToothSelectionBase;

export type HandleSelect = (changes: Partial<DentalFormulaSelection>) => void;

export type DentalFormulaState = Partial<
    Record<FiveZoneToothNumber, FiveZoneToothState> | Record<FourZoneToothNumber, FourZoneToothState>
> & {
    jaw?: JawState;
};

export type JawState = {
    upper?: ConditionId | '';
    lower?: ConditionId | '';
};

export type JawSelection = {
    upper?: boolean;
    lower?: boolean;
};

export type DentalFormulaSelection = Partial<
    Record<FiveZoneToothNumber, FiveZoneToothSelectionBase> | Record<FourZoneToothNumber, FourZoneToothSelectionBase>
> & {
    jaw?: JawSelection;
};

export interface SurfaceIconProps {
    handleClick?: (zone: FourZoneSurfaceNumber | FiveZoneSurfaceNumber) => void;
    isZoneDisabled?: (zone: FourZoneSurfaceNumber | FiveZoneSurfaceNumber) => boolean;
    zoneColors: FourZoneSurfaceColors | FiveZoneSurfaceColors;
    dataTest?: string;
    readonly: boolean;
}
